import * as React from "react"

/**
 * Track whether a resource has finished loading at least once, given
 * its current `isLoading` flag. Used to show initial-load skeletons for
 * decorative content (stat cards, summary rows) that shouldn't
 * re-shimmer on every subsequent filter/sort round-trip.
 *
 * Returns true from the first false-transition onwards. Stays true
 * across StrictMode re-mounts because it's a plain ref.
 */
export function useHasLoadedOnce(isLoading: boolean): boolean {
  const [hasLoaded, setHasLoaded] = React.useState(false)
  React.useEffect(() => {
    if (!isLoading && !hasLoaded) setHasLoaded(true)
  }, [isLoading, hasLoaded])
  return hasLoaded
}
